<div class="add-user-group-listing-main">
  <div class="d-flex justify-content-between">
    <img
      *ngIf="!userStepper"
      src="/assets/svg/ico-chevron-back-outline.svg"
      class="back-navigation hide"
      (click)="closeDialog()"
    />

    <img
      src="/assets/svg/ico-chevron-back-outline.svg"
      alt="back button"
      class="pointer-cursor pb-2"
      *ngIf="userStepper && !isUserProfileFlow"
      (click)="parentStepper(-1)"
    />

    <img
      src="/assets/svg/ico-chevron-back-outline.svg"
      alt="back button"
      class="pointer-cursor pb-2"
      *ngIf="userStepper && isUserProfileFlow"
      (click)="parentStepper(-4)"
    />
    <div>
      <p
        class="build-user-group col-7 pl-4 bold-font text-center"
        *ngIf="!userStepper"
      >
        {{ 'GROUPS' | translate }}
      </p>
      <div class="text-center">
        <h4 class="mb-0 ml-4">
          {{ userName }}
        </h4>
        <h1 class="modal-title mt-10 mb-0 ml-3" *ngIf="userStepper">
          {{ 'USER_ADD_USER' | translate }}
        </h1>
      </div>
    </div>
    <div class="row align-items-center">
      <ng-container *appHideAccess="commonAccessControl">
        <div class="col-6 d-flex setting-icon justify-content-end">
          <button
            type="button"
            class="btn outline-none pointer-cursor"
            (click)="addUserGroup()"
            [controlDisabled]="[PageName.Users, CONSTANTS.CREATE]"
          >
            <!-- this is modal button for add user -->
            <img src="assets/svg/ico-add.svg" />

            <strong>
              <ng-container *ngIf="!userStepper"> </ng-container>
              <ng-container *ngIf="userStepper"></ng-container>
            </strong>
          </button>
        </div>
      </ng-container>

      <div class="col-1">
        <!-- dynamic back button render -->
        <ng-content select="[backButton]"></ng-content>
      </div>
    </div>
  </div>
  <div class="mt-4 row justify-content-center">
    <div class="col-8">
      <h1 class="text-center heading1" *ngIf="!userStepper">
        {{ 'USER_GROUP' | translate }}
      </h1>
      <h1 class="text-center heading1" *ngIf="userStepper">
        {{ 'ASSIGN_A_GROUP' | translate }}
      </h1>
    </div>

    <div class="col-10" *ngIf="!userStepper">
      <p class="sub-heading pt-7 pb-20">
        {{ 'CREATE_A_NEW_USER_GROUP_OR_EDIT' | translate }}
      </p>
    </div>

    <div class="col-10" *ngIf="userStepper">
      <p class="sub-heading pt-7 pb-20">
        {{ 'GRANT_ACCESS_TITLE_TO_USER_BY_GROUP' | translate }}
      </p>
    </div>
  </div>
  <ng-container *ngIf="userGroupList?.length">
    <div class="row d-flex">
      <div class="col-11 justify-content-between">
        <app-search-field
          (searchCriteria)="searchThis($event)"
          class="col-12"
        ></app-search-field>
      </div>
    </div>
    <br />
  </ng-container>
  <div class="modal-body">
    <div
      class="w-100 h-100 d-flex flex-column justify-content-center align-items-start"
    ></div>
    <ng-container *ngIf="userStepper && !isUserProfileFlow">
      <form
        [formGroup]="formGroupDevice"
        tabindex="0"
        (keyup.enter)="submitToParent(+1)"
        #groupListing
      >
        <div class="modal-body">
          <div
            class="w-100 h-100 d-flex flex-column justify-content-center align-items-start"
          ></div>
          <div class="group-listing">
            <div class="scroll-container pr-2">
              <ng-container
                *ngFor="
                  let userGroup of userGroupList | orderBy : ['userGroupName'];
                  let i = index
                "
              >
                <div
                  class="col-11 pl-2"
                  *ngIf="checkIfNew(userGroup?.userGroupName)"
                >
                  <div class="heading mb-1 mt-2">
                    {{ userGroup?.userGroupName?.charAt(0).toUpperCase() }}
                  </div>
                </div>
                <div
                  (click)="radioRef.click()"
                  class="checked-card mr-2 row d-flex"
                  [class.active]="userGroup.active"
                  [class.disabled-click]="userGroup.alreadySelected"
                >
                  <div class="col-2">
                    <span>
                      <img
                        class="group-icon"
                        src="/assets/images/group-icon.png"
                        alt="ico-group-with-black-circle"
                      />
                    </span>
                  </div>
                  <div class="pl-2 col-8">
                    <input
                      type="radio"
                      class="d-none"
                      [value]="userGroup"
                      #radioRef
                      (click)="activate(userGroup)"
                      formControlName="group"
                    />
                    <h3 class="titles">
                      <app-with-tooltip [showHelpCursor]="true">
                        {{ userGroup.userGroupName }}
                      </app-with-tooltip>
                    </h3>
                    <!-- <p class="detail">
                      <app-with-tooltip [showHelpCursor]="true">
                        {{ userGroup.userGroupDescription }}
                      </app-with-tooltip>
                    </p> -->
                  </div>
                  <div class="col-2">
                    <span>
                      <img
                        [src]="
                          userGroup.active
                            ? '/assets/svg/ico-checkmark-circle-outline.svg'
                            : '/assets/svg/ico-circle.svg'
                        "
                        class="check-circles"
                      />
                    </span>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </form>
    </ng-container>

    <ng-container *ngIf="userStepper && isUserProfileFlow">
      <!-- error no building  start-->
      <ng-container *ngIf="!userGroupList?.length">
        <div
          class="d-flex flex-column justify-content-center align-items-center no-record"
        >
          <div
            class="text-container d-flex flex-column justify-content-center align-items-center"
          >
            <div class="icon-container">
              <img
                src="assets/svg/ico-user-list-group-icon.svg"
                class="group-icon"
              />
            </div>
            <div class="text-center mt-3">
              <p>{{ 'NO_USER_GROUPS_AVAILABLE' | translate }}</p>
            </div>
          </div>
        </div>
      </ng-container>
      <!-- error no building  end -->

      <div *ngIf="userGroupList?.length" class="group-listing">
        <div class="scroll-container pr-2">
          <ng-container
            *ngFor="
              let userGroupItem of userGroupList
                | sortBy : 'userGroupName' : 'asc'
            "
          >
            <div class="card mb-3 item">
              <div
                class="row py-3 mx-2 pointer-cursor"
                (click)="sendSelectedGroup(userGroupItem)"
              >
                <div class="col-2 pl-1">
                  <img
                    src="assets/svg/ico-lock-user-access-circle.svg"
                    class="item-icon"
                  />
                </div>
                <div class="col-8 pl-2 mt-auto mb-auto heading3">
                  <app-with-tooltip [showHelpCursor]="true">
                    {{ userGroupItem?.userGroupName }}
                  </app-with-tooltip>
                </div>
                <div class="col-2 pr-1 text-right align-self-center">
                  <img src="assets/svg/ico-chevron-forward-outline.svg" />
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="!userStepper">
      <div class="group-listing">
        <div class="scroll-container pr-2">
          <ng-container *ngIf="isEmpty(userGroupList)" class="no-user-group">
            <div class="content">
              <div
                class="d-flex flex-column justify-content-center align-items-center h-100"
              >
                <div
                  class="text-container d-flex flex-column justify-content-center align-items-center"
                >
                  <div class="icon-container">
                    <img
                      src="assets/svg/ico-lock-user-access-circle.svg"
                      class="home-icon"
                    />
                  </div>
                  <div class="text-center mt-3">
                    <p>{{ 'NO_USER_GROUPS_AVAILABLE' | translate }}</p>
                  </div>
                </div>
              </div>
              <div></div>
            </div>
          </ng-container>

          <ng-container
            *ngFor="
              let userGroupItem of userGroupList
                | sortBy : 'userGroupName' : 'asc'
            "
          >
            <div
              class="col-11 pl-2"
              *ngIf="checkIfNew(userGroupItem?.userGroupName)"
            >
              <div class="heading mb-1 mt-2">
                {{ userGroupItem?.userGroupName?.charAt(0).toUpperCase() }}
              </div>
            </div>
            <div class="card mb-3 item">
              <div
                class="row py-3 mx-2 pointer-cursor"
                (click)="editUserGroup(userGroupItem)"
              >
                <div class="col-2 pl-1">
                  <img
                    src="assets/svg/ico-lock-user-access-circle.svg"
                    class="item-icon"
                  />
                </div>
                <div class="col-8 pl-2 mt-auto mb-auto heading3">
                  <app-with-tooltip [showHelpCursor]="true">
                    {{ userGroupItem?.userGroupName }}
                  </app-with-tooltip>
                </div>
                <div class="col-2 pr-1 text-right align-self-center">
                  <img src="assets/svg/ico-chevron-forward-outline.svg" />
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </ng-container>

    <div class="row">
      <ng-container *ngIf="!userStepper">
        <button
          class="btn btn-danger px-3 w-100 save-btn"
          type="button"
          (click)="closeDialog()"
        >
          {{ 'DONE' | translate }}
        </button>
      </ng-container>

      <ng-container *ngIf="userStepper && isUserProfileFlow">
        <button
          class="btn btn-danger px-3 w-100 save-btn"
          type="button"
          (click)="parentStepper(-4)"
        >
          {{ 'DONE' | translate }}
        </button>
      </ng-container>

      <ng-container *ngIf="userStepper && !isUserProfileFlow">
        <button
          class="btn btn-danger px-3 w-100 save-btn"
          type="button"
          (click)="submitToParent(+1)"
        >
          {{ 'CONTINUE' | translate }}
        </button>
      </ng-container>
    </div>
  </div>
</div>
